import React, { FC, useMemo } from 'react';
import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { Box } from '@cp/ds/src/components/box';
import { ReadIcon } from '@cp/ds/src/icons/read';
import { SentIcon } from '@cp/ds/src/icons/sent';
import { useIsDelivered } from '../../model/useIsDelivered';
import { useIsRead } from '../../model/useIsRead';
import { useCurrentDialogMember } from '../../model';

export interface MessageDeliveryProps {
  message: DialogMessageViewModel;
}

export const MessageDelivery: FC<MessageDeliveryProps> = ({ message }) => {
  const currentDialogMebmer = useCurrentDialogMember();
  const isDelivered = useIsDelivered(message);
  const isRead = useIsRead(message);

  const icon = useMemo(() => {
    if (currentDialogMebmer?.id !== message.author.id) {
      return null;
    }

    if (isRead) {
      return <ReadIcon sx={{ fontSize: '18px' }} />;
    }
    if (isDelivered) {
      return <SentIcon sx={{ fontSize: '18px' }} />;
    }
    return null;
  }, [currentDialogMebmer?.id, isDelivered, isRead, message.author.id]);

  return (
    <Box component="span" sx={{ display: 'inline-flex' }}>
      {icon}
    </Box>
  );
};
